// SUMMARY: Which pages have a guide, and what each of their steps points at. Adding a guide = adding an
// entry here plus `data-guide` attributes on the page and the matching i18n strings under `guide.steps`.

import type { PageGuide } from './types'

const CHAT_GUIDE: PageGuide = {
	path: '/dashboard/chat',
	steps: [
		{ id: 'chat.input', target: '[data-guide="chat-input"]' },
		{ id: 'chat.attach', target: '[data-guide="chat-attach"]' },
		{ id: 'chat.search', target: '[data-guide="chat-search"]' },
		{ id: 'chat.gemini', target: '[data-guide="chat-gemini"]' },
		{ id: 'chat.style', target: '[data-guide="chat-style"]' },
	],
}

const GUIDES: PageGuide[] = [CHAT_GUIDE]

/** The guide for a pathname, or null when that page has none (the help button is then disabled). */
export function getGuideForPath(pathname: string | null): PageGuide | null {
	if (!pathname) return null
	return GUIDES.find((guide) => guide.path === pathname) ?? null
}
